<template>
  <div>
    <!-- Title-->
    <div>
      <v-alert :type="alert_type" :modelValue="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <div>
      <HeaderComponent :headerTitle="headerText" :router-link="getRouterLink()"
        :router-link-text="headerSubText1" :return-condition="true"
        :component-name="componentsName()" />
    </div>

    <!-- Image show popup -->
    <v-dialog v-model="dialogVisible" persistent max-width="600">
      <v-card class="v-card-100">
        <v-card-title class="d-flex">
          <span class="headline">Images</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider :thickness="2" class="border-opacity-25 m-0"/>
        <v-card-text>
          <v-row>
            <v-col v-for="(imageUrl, index) in item_images" :key="index" cols="4">
              <v-img :src="imageUrl" width="100%" contain></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Test Result Popup -->
    <v-row justify="center">
      <v-dialog v-model="testResultPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card class="v-card-100">
            <v-card-title class="d-flex">
              <span>Test Results</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="testResultPopup = !testResultPopup">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Ticket Resolution</span>
                  </v-col>
                  <v-col cols="6">
                    <!-- Replace part -->
                    {{ item_details.ticket_resolution ? item_details.ticket_resolution : "-" }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Item Decision</span>
                  </v-col>
                  <v-col cols="6">
                    <!-- Return -->
                    {{ item_details.item_decision ? item_details.item_decision : "-" }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Inspection Questions</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <div v-if="item_details.condition_questions && item_details.condition_questions.length">
                      <ul>
                        <li style="list-style-type:none;" v-for="item in item_details.condition_questions"
                          :key="item.question">
                          Q. {{ item.question }} : {{ item.answer }}
                        </li>
                      </ul>
                    </div>
                    <span v-else>-</span><br>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Estimated Service Cost (₹)</span>
                  </v-col>
                  <v-col cols="6" v-if="item_details.estimated_service_cost == 0">
                    {{ item_details.estimated_service_cost }}
                  </v-col>
                  <v-col cols="6" v-else-if="item_details.estimated_service_cost == null">
                    {{ "-" }}
                  </v-col>
                  <v-col cols="6" v-else>
                    {{ item_details.estimated_service_cost }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Type of Defect</span>
                  </v-col>
                  <v-col cols="6">
                    <!-- In Policy -->
                    {{ item_details.type_of_defect ? item_details.type_of_defect : "-" }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Service Engineer Name</span>
                  </v-col>
                  <v-col cols="6">
                    <!-- John Abrahim -->
                    <span>{{ item_details.service_partner_name ? item_details.service_partner_name : '-' }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Defective Spare Parts Information</span>
                  </v-col>
                  <v-col cols="6">
                    <div v-if="item_details.defective_spare_part_info && item_details.defective_spare_part_info.length">
                      <li style="list-style-type:none;" v-for="spare_info in item_details.defective_spare_part_info">
                        {{ spare_info }}
                      </li>
                    </div>
                    <span v-else>-</span>
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-card class="v-card v-sheet theme--light mt-5 overflow-auto" :height="minTableHeight">
      <v-card-text>
        <!-- v-expansion-panels for different sections -->
        <div
          v-if="(activeTab == 'Warranty Details' || headerText === 'D2C Return Approval' || headerText === 'Internal Return Request Approval' || headerText === 'Dealer/Partner Return Approval') && (action !== 'from_home_approve')">
          <div class="p-3">
            <!-- Customer Entity Details -->
            <v-row class="p-3 customer-details">
              <label>Customer Entity Details</label>
            </v-row>
            <v-row class="p-3">
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Customer/Entity Name*</p>
                <p>{{ item_details.customer_name ? item_details.customer_name : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Customer/Entity Type</p>
                <p>{{ item_details.customer_type ? item_details.customer_type : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Contact Numer*</p>
                <p>{{ item_details.contact_number ? item_details.contact_number : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Alternate Contact Number*</p>
                <p>{{ item_details.alternate_contact_number ? item_details.alternate_contact_number : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Item Location(Address)*</p>
                <p>{{ item_details.item_location ? item_details.item_location : "-" }}</p>
              </v-col>
            </v-row>

            <!-- Item Details -->
            <v-row class="p-3 customer-details">
              <label>Item Details</label>
            </v-row>
            <v-row class="p-3">
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Tag Id</p>
                <p>{{ item_details.tag_number ? item_details.tag_number : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Article Id</p>
                <p>{{ item_details.sku_code ? item_details.sku_code : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Article Description</p>
                <p>{{ item_details.sku_description ? item_details.sku_description : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Alternate Contact Number*</p>
                <p>{{ item_details.alternate_contact_number ? item_details.alternate_contact_number : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Serial Number</p>
                <p>{{ item_details.serial_number ? item_details.serial_number : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Article Id Being Sale On Exchange</p>
                <p>-</p>
              </v-col>
            </v-row>

            <!-- Test Details -->
            <v-row class="p-3 customer-details">
              <label>Test Details</label>
            </v-row>
            <v-row class="p-3">
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Test Results</p>
                <p><a @click="showTestResult()" style="color: #1976d2;"><u>View</u></a></p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">AI Discrepancy Report</p>
                <p>-</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Service Partner</p>
                <p>{{ item_details.service_partner_name ? item_details.service_partner_name : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Service Technician</p>
                <p>{{ item_details.service_technician_name ? item_details.service_technician_name : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Validation Status</p>
                <p>{{ item_details.policy ? item_details.policy : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Item condition</p>
                <p>{{ item_details.repairable_status ? item_details.repairable_status : "-" }}</p>
              </v-col>
            </v-row>

            <!-- Customer Declaration Details -->
            <v-row class="p-3 customer-details">
              <label>Customer Declaration</label>
            </v-row>
            <v-row class="p-3">
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Issue Reported</p>
                <p>{{ item_details.issue_reported ? item_details.issue_reported : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Type of damage</p>
                <p>{{ item_details.type_of_incident_or_damage ? item_details.type_of_incident_or_damage : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Vendor Responsible for Damage</p>
                <p>{{ item_details.vendor_responsible ? item_details.vendor_responsible : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Condition Questions</p>
                <p>-</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Images</p>
                <a @click="viewCustomerDeclarationImages(item_details)" v-if="item_details.images != ''">
                  <span style="text-decoration: underline;color:#1976d2;">View All</span>
                </a>
                <span v-else>-</span>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Videos return file</p>
                <p>-</p>
              </v-col>
            </v-row>

            <!-- Other Details -->
            <v-row class="p-3 customer-details">
              <label>Other Details</label>
            </v-row>
            <v-row class="p-3">
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Channel</p>
                <p>{{ item_details.channel ? formatResponse(item_details.channel) : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Return Sub-Type</p>
                <p>{{ item_details.return_request_sub_type ? formatResponse(item_details.return_request_sub_type) : "-"
                  }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Return Reason</p>
                <p>{{ item_details.return_reason ? formatResponse(item_details.return_reason) : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Return Sub-Reason</p>
                <p>{{ item_details.return_sub_reason ? formatResponse(item_details.return_sub_reason) : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Branch</p>
                <p>{{ item_details.branch ? formatResponse(item_details.branch) : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Region</p>
                <p>{{ item_details.region ? formatResponse(item_details.region) : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Zone</p>
                <p>{{ item_details.zone ? formatResponse(item_details.zone) : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Sales Manager</p>
                <p>{{ item_details.sales_manager ? formatResponse(item_details.sales_manager) : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Ticket Initiator</p>
                <p>{{ item_details.customer_service_executive ? formatResponse(item_details.customer_service_executive) :
                  "-"}}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Repair Partner</p>
                <p>{{ formatResponse(item_details.repair_partner) }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Repair Executive</p>
                <p>{{ formatResponse(item_details.repair_executive) }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Grading Partner</p>
                <p>{{ formatResponse(item_details.grading_partner) }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Grading Executive</p>
                <p>{{ formatResponse(item_details.grading_executive) }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Request Creation Date</p>
                <p>{{ formatResponse(item_details.created_date) }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Ageing</p>
                <p v-if="item_details.ageing == 0">{{ item_details.ageing }}</p>
                <p v-else-if="item_details.ageing == null">{{ "-" }}</p>
                <p v-else>{{ item_details.ageing }}</p>
              </v-col>
            </v-row>

            <!-- Status And Decision Details -->
            <v-row class="p-3 customer-details">
              <label>Status And Decision Details</label>
            </v-row>
            <v-row class="p-3">
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Purchase Price (₹)</p>
                <p v-if="item_details.purchase_price == 0">{{ item_details.purchase_price }}</p>
                <p v-else-if="item_details.purchase_price == null">{{ "-" }}</p>
                <p v-else>{{ item_details.purchase_price }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Purchase Date</p>
                <p>{{ item_details.purchase_date ? item_details.purchase_date : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Depreciation (₹)</p>
                <p v-if="item_details.depriciation == 0">{{ item_details.depriciation }}</p>
                <p v-else-if="item_details.depriciation == null">{{ "-" }}</p>
                <p v-else>{{ item_details.depriciation }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Expected Liquidation Value (₹)</p>
                <p v-if="item_details.expected_liquidation == 0">{{ item_details.expected_liquidation }}</p>
                <p v-else-if="item_details.expected_liquidation == null">{{ "-" }}</p>
                <p v-else>{{ item_details.expected_liquidation }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Sub-Request Status</p>
                <p>{{ item_details.status ? item_details.status : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Approval Pending At</p>
                <p>{{ item_details.approval_pending_from ? item_details.approval_pending_from : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Approved By</p>
                <p>{{ item_details.approved_by ? item_details.approved_by : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Customer Resolution Decision</p>
                <p>{{ item_details.customer_resolution_decision ? item_details.customer_resolution_decision : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Customer Resolution Status</p>
                <p> {{ item_details.customer_resolution_status ? item_details.customer_resolution_status : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Item Decision</p>
                <p>{{ item_details.item_decision ? item_details.item_decision : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Item Decision Status</p>
                <p> {{ item_details.item_decision_status ? item_details.item_decision_status : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">CSE Comment</p>
                <p>{{ item_details.cse_comments ? item_details.cse_comments : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Re-Propose Comment</p>
                <p>{{ item_details.re_propose_comments ? item_details.re_propose_comments : "-" }}</p>
              </v-col>
              <v-col col="12" sm="4" md="4" lg="4">
                <p class="detail-heading">Recommandation Comment</p>
                <p>{{ item_details.recommend_comments ? item_details.comments : "-" }}</p>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
import approval_decision from "./../../../../components/api/v2/return_approval/approval_decision.vue"

export default {
  components: {
    HeaderComponent, approval_decision
  },
  data() {
    return {
      table_data: [],
      CustomerLabelList: ["Customer Entity Details", "Item Details", "Test Details", "Customer Decelaration", "Other Details", "Status And Decision Details"],
      headerText: "",
      headerSubText1: "Approval Decision",
      headerSubText2: "",
      action: "Sub Request",
      testResultPopup: false,
      hideApproval: false,
      item_id: "",
      item: [],
      item_images: [],
      tab: "warranty Details",
      tabs: ["Warranty Details", "Warranty Claim History"],
      headers: [
        { text: "Warranty Claim Date", align: "start", sortable: false, value: "warranty_claim_date" },
        { text: "Issue", value: "issue" },
        { text: "Warranty Resolution Date", value: "warranty_resolution_date" }
      ],
      activeTab: "Warranty Details",
      selected: "",
      ItemConditionPopup: false,
      d2cReturn: [],
      d2cReturn_table_data: [],
      item_details: [],
      alert_type: "success",
      alert_message: "success",
      alert: false,
      dialogVisible: false,
      minTableHeight: "200px",
      action: '',
      selected_headers: [
        {
          text: "Sub-request",
          align: "start",
          sortable: false,
          value: "return_sub_request_id"
        },
        { text: "Ageings", value: "ageing" },
        { text: "Customer", value: "customer_name" },
        { text: "Location", value: "item_location" },
        { text: "Branch", value: "branch" },
        { text: "Region", value: "region" },
        { text: "Zone", value: "zone" },
        { text: "Validation", value: "policy" },
        { text: "Repairable", value: "repairable_status" },
        { text: "Repair As Value(₹)", value: "repair_cost" },
        { text: "Repair Cost %", value: "repair_cost_percent" },
        {
          text: "Customer Resolution Decision", value: "customer_resolution_decision"
        },
        { text: "Images", value: "images" },
        { text: "Item Decision", value: "item_decision" }

      ]
    };
  },
  async created() {
    this.item_id = this.$store.state.requestIDs.id;
    this.action = this.$store.state.requestAction
    this.headerText = this.$store.state.subId;
    this.itemDetailsFtechData();
  },
  mounted() {
    this.calculateTableHeight();
    window.addEventListener('resize', this.calculateTableHeight);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.calculateTableHeight);
  },
  methods: {
    calculateTableHeight() {
      const viewportHeight = window.innerHeight;
      this.minTableHeight = (viewportHeight - 180) + 'px'
    },
    // show Test Result Popup
    formatResponse(response) {
      return response ? response.replace(/_/g, ' ') : "-";
    },
    showTestResult() {
      this.testResultPopup = true;
    },
    getRouterLink() {
      if (this.headerSubText1 === "Approval Decision") {
        this.$store.commit("setSelectedLot", {
          lot: '',
          action: "from_home_approve",
        });
        return { name: "sub_request_approval" };
      }
    },
    viewCustomerDeclarationImages(item) {
      this.dialogVisible = true;
      this.item_images = item.images
    },
    componentsName() {
      if (this.headerSubText1 === "Approval Decision") {
        return this.$store.state.requestIDs.return_sub_request_id
      }
    },
    getRouterLinkText() {
      if (this.headerText === "D2C Return Approval") {
        return this.headerText;
      } else if (this.headerText === "Internal Return Request Approval") {
        return this.headerText;
      } else if (this.headerText === "Warranty Claim Approval") {
        return this.headerText;
      } else if (this.headerText === "Dealer/Partner Return Approval") {
        return this.headerText;
      } else if (this.headerText === "Approval Decision") {
        return this.headerText;
      }
    },
    formattedDate(date) {
      const d = new Date(date);
      const day = String(d.getUTCDate()).padStart(2, '0');
      const month = String(d.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
      const year = d.getUTCFullYear();

      return `${day}/${month}/${year}`;
    },
    itemDetailsFtechData() {
      this.loading = true;
      this.$httpSecured
        .get(
          `/api/v1/warehouse/return_initiation/return_approvals/${this.item_id}`
        )
        .then(response => {
          if (response.data) {
            this.item_details = response.data.return_item;
            this.table_data = response.data.return_item.warranty_claim_data
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.scrollToTop();
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    }
  }
}
</script>
<style scoped>
.customer-details {
  background-color: #EAF4FF;
}

.customer-details label {
  color: #002F9E;
  font-weight: 600;
  font-size: 18px;
}

.detail-heading {
  font-weight: 600;
  color: #2D2D2D;
  font-size: 14px;
}
</style>